export default {
  methods: {
    async updateTeamTours() {
      await this.$store.dispatch("company/getSelectedTeamTours");
      await this.$store.dispatch("company/getSelectedTeamDetails");
    },
  }
};
